/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { PopupCork } from '../../components'

const TestingCork = () => {

  return (
    <PopupCork />
  )
}

export default React.memo(TestingCork)
